import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DialogMessageParticipantKind } from '../../../../common/model/const/enum';
import { LanguageService } from '../../../../core/service/language.service';

@Component({
    selector: 'app-chat-user-logo',
    templateUrl: './chat-user-logo.component.html',
    styleUrls: ['./chat-user-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatUserLogoComponent {
  @Input() senderType: DialogMessageParticipantKind;

  constructor(private languageService: LanguageService) {}

  get initialLetter(): string {
    switch (this.senderType) {
      case DialogMessageParticipantKind.Representative:
        return this.languageService.instant('CHAT.ICON_LETTER.REPRESENTATIVE');
      case DialogMessageParticipantKind.Tenant:
        return this.languageService.instant('CHAT.ICON_LETTER.TENANT');
      case DialogMessageParticipantKind.Office:
        return this.languageService.instant('CHAT.ICON_LETTER.OFFICE');
      default:
        return this.languageService.instant('CHAT.ICON_LETTER.DEFAULT');
    }
  }

  get letterColor() {
    switch (this.senderType) {
      case DialogMessageParticipantKind.Representative:
      case DialogMessageParticipantKind.Tenant:
        return {
          color: 'white',
          'background-color': '#F4A909',
        };
      case DialogMessageParticipantKind.Office:
        return {
          color: 'white',
          'background-color': '#4E43A4',
        };
      default:
        return {
          color: 'white',
          'background-color': 'black',
        };
    }
  }
}
